import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Container from '../../components/Container';
import {Grid, ListItem, Box} from '@material-ui/core'
import Typography from '../../components/CustomTypo'
import {BackOnPrimaryIcon} from '../../components/icons'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress'
import Barcode from 'react-barcode'

const styles = theme => ({
    barcode_card:{
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
    }
});
function BarcodeView(props){
    const { classes, t, onShowBarcode, authentication_code} = props;
    return (
        <DrawerCustom 
            open={props.open} 
            onClose = {onShowBarcode}
            title = {t('barcode')} 
            children={        
                <Grid item className={classes.container}>
                    <Grid xs={12} container item justify="center" className={classes.barcode_card}>
                        {authentication_code?<Barcode value={authentication_code} />:<CustomizedCircularProgress color="primary"/>}
                    </Grid>
                </Grid>}/>
    );
}

export default withStyles(styles)(withTranslation()(BarcodeView));